import _ from 'lodash';
import moment from 'moment';
import React, { useState, useEffect } from 'react';
import Dialog from 'src/components/common/Dialog.redesign';
import Button from 'src/components/controls/forms/redesign/FormButton';
import SurfaceTract from 'src/models/SurfaceTract';
import TractDetail from 'src/models/tract_detail/TractDetail';

export interface IDeleteTractDialogProps {
    navigate: (path: string) => void;
    confirmDelete: () => void;
    onCloseDialog?: () => void;
}

export type IDeleteTractDialogStateProps = {
    tractType: number;
    horizons: Array<TractDetail>;
    childSurfaceTracts: Array<SurfaceTract>;
    onCloseDeleteTractDialog: () => void;
};

type IDeleteTractDialogPageProps = IDeleteTractDialogProps & IDeleteTractDialogStateProps;

const DeleteTractDialog = (props: IDeleteTractDialogPageProps) => {
    const [childTracts, setChildTracts] = useState<TractDetail[]>([]);
    const [childSurfaceTracts, setChildSurfaceTracts] = useState<SurfaceTract[]>([]);

    useEffect(() => {
        if (props.tractType > 0) {
            setChildSurfaceTracts(props.childSurfaceTracts);
        } else {
            setChildTracts(props.horizons);
        }
     }, [props.tractType]);

    useEffect(() => {
        console.log(childTracts.length);
     }, [childTracts]);

    const childTractCard = (tract: TractDetail) => {
        return (
            <div
                style={{ backgroundColor: 'white', borderBottom: '1px solid grey', padding: '.5rem', display: 'flex' }}
            >
                <div style={{ width: '5%' }}>{tract?.id || 'N/A'}</div>

                <div style={{ width: '20%' }}>{tract?.tractName || 'N/A'}</div>

                <div style={{ width: '10%' }}>{props?.tractType === 0 ? 'Mineral' : 'Surface'  || 'N/A'}</div>

                <div style={{ width: '8%' }}>{`${tract?.horizons?.length}`}</div>

                <div style={{ width: '14%' }}>{moment(tract?.horizons?.[0]?.createdDate)?.format('MM/DD/YYYY') || 'N/A'}</div>

                <div style={{ width: '21%' }}>{tract?.horizons?.[0]?.createdBy || 'N/A'}</div>

                <div style={{ width: '15%' }}>{tract?.horizons?.[0]?.mineralOwnerships?.length || 'N/A'}</div>
            </div>
        );
    };

    const childSurfaceTractCard = (tract: SurfaceTract) => {
        return (
            <div
                style={{ backgroundColor: 'white', borderBottom: '1px solid grey', padding: '.5rem', display: 'flex' }}
            >
                <div style={{ width: '5%' }}>{tract?.id || 'N/A'}</div>

                <div style={{ width: '20%' }}>{tract?.name || 'N/A'}</div>

                <div style={{ width: '10%' }}>{props?.tractType === 0 ? 'Mineral' : 'Surface'  || 'N/A'}</div>

                <div style={{ width: '8%' }}>{`${tract?.mineralTracts?.length || 'N/A'}`}</div>

                <div style={{ width: '14%' }}>{moment(tract?.recordDate)?.format('MM/DD/YYYY') || 'N/A'}</div>

                <div style={{ width: '21%' }}>{tract?.grantee || 'N/A'}</div>

                <div style={{ width: '15%' }}>{tract?.owners?.length || 'N/A'}</div>
            </div>
        );
    };

    const childTractCardContainer = () => {
        if (props.tractType === 0) {
            return childTracts?.map((chilTract: TractDetail) => { return childTractCard(chilTract); });
        } else {
            return childSurfaceTracts?.map((chilTract: SurfaceTract) => { return childSurfaceTractCard(chilTract); });
        }
    };

    const confirmDelete = () => {
        props.confirmDelete();
        props.onCloseDialog();
    };

    const onDeleteTractDialogClose = () => {
        props.onCloseDeleteTractDialog();
        props.onCloseDialog();
    };

    const childTractList = () => {
        if (childTracts?.length > 0 || childSurfaceTracts?.length > 0) {
            return (
                <div style={{ marginBottom: '1rem', width: '60vw' }}>
                    <div>Please address Subordinate tracts shown below before deleting this tract.</div>
                    <div>
                        <fieldset style={{ padding: '.3rem 0', borderWidth: '1px 0 0 0' }}>
                            <legend className="legend">Subordinate Tracts</legend>
                        </fieldset>
                    </div>

                    <div style={{ display: 'flex', padding: '.5rem' }}>
                        <div style={{ width: '5%' }}>Tract Id</div>
                        <div style={{ width: '20%' }}>Tract Name</div>
                        <div style={{ width: '10%' }}>Tract Type</div>
                        <div style={{ width: '8%' }}>Horizons</div>
                        <div style={{ width: '14%' }}>{props.tractType === 0 ? `Creation Date` : `Record Date`}</div>
                        <div style={{ width: '21%' }}>{props.tractType === 0 ? `Created By` : `Grantee`}</div>
                        <div style={{ width: '15%' }}>Mineral Owners</div>
                    </div>

                    <div>{childTractCardContainer()}</div>
                    <div className="mt-2 button-row">
                        <Button text="Cancel" onClick={onDeleteTractDialogClose} />
                    </div>
                </div>
            );
        } else {
            return (
                <>
                    <div>Are you sure that you want to permanently delete the selected tract?</div>
                    <div className="mt-2 button-row">
                        <Button text="OK" onClick={confirmDelete} intent="primary" />
                        <Button text="Cancel" onClick={props.onCloseDialog} />
                    </div>
                </>
            );
        }
    };

    return (
        <Dialog title="Tract References Subordinate Tracts">
            <div>
                {(childTracts?.length > 0 || childSurfaceTracts?.length > 0) && (childTractList())}
                {childTracts?.length < 1 && childSurfaceTracts?.length < 1 && (<div>Fetching child tracks...</div>)}
            </div>
        </Dialog>
    );
};

export default DeleteTractDialog;



// WEBPACK FOOTER //
// ./src/components/project/sections/TractComponents/DeleteTractDialog.tsx